module.exports = __webpack_public_path__ + "img/sort／web／Fighting@2x.f338ea72.png";